import { Spinner, Image, Link } from 'Common';
import { HoverImageLink, Slider } from 'Component';
import { useSliderSettings } from 'hookApi/useSliderSettings';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInsuranceCompaniesRequest } from 'redux/actions';
import { getInsuranceCompanies } from 'redux/query';
import 'slick-carousel/slick/slick-theme.css';
import 'slick-carousel/slick/slick.css';
import Style from './HealthCooperationSlider.style';
import { linkHandler } from 'utils/linkHandler';

export const HealthCooperationSlider = ({ headline, children, additionalEntries = [], allowLinks = true, dotsColor = 'pink' }) => {
  const dispatch = useDispatch();
  const [totalLogoCount, setTotalLogoCount] = useState(0);

  useEffect(() => {
    dispatch(getInsuranceCompaniesRequest(true));
  }, [dispatch]);

  const insuranceCompanies = useSelector(getInsuranceCompanies);

  const sliderEntries = useMemo(() => {
    return [
      ...insuranceCompanies.filter((company) => !!(company?.zppCourseOffers || []).length && !!company.cooperationLogo),
      ...additionalEntries
    ];
  }, [insuranceCompanies]);

  useEffect(() => {
    setTotalLogoCount(sliderEntries.length);
  }, [sliderEntries]);

  const settings = useSliderSettings(totalLogoCount);

  if (!sliderEntries || totalLogoCount === 0) {
    return <Spinner />;
  }

  const renderSliderEntry = (cooperation) => {
    if (!allowLinks) {
      return <Image key={cooperation.name} src={cooperation.cooperationLogo} className="logo" />;
    }
    const linkProps = {};
    if (cooperation?.slug) {
      linkProps.to = linkHandler.get('healthInsuranceCooperation', { cooperation: cooperation.slug });
    }
    return (
      <HoverImageLink
        {...linkProps}
        key={`cooperation-${cooperation.slug}`}
        image={cooperation.cooperationLogo}
        hoverImage={cooperation.cooperationLogoHover || cooperation.cooperationLogo}
        className="logo"
        aria-label={`${cooperation.name} – Mehr zur Kooperationspartner und Kostenübernahme erfahren`}
        alt={`${cooperation.name} – Mehr zur Kooperationspartnerlogo`}
      />
    );
  };

  return (
    <Style className="text-center health-cooperation-slider">
      {headline}
      <div className="slider-wrapper" aria-hidden="true">
        <Slider
          key={settings.initialSlide}
          settings={settings}
          className={`${dotsColor}-dots`}
          ariaLabels={{
            previous: 'Vorherige Krankenkasse anzeigen',
            next: 'Nächste Krankenkasse anzeigen'
          }}
        >
          {sliderEntries.map(renderSliderEntry)}
        </Slider>
        {children}
      </div>
      <div className="sr-only">
        <ul>
          {sliderEntries.map((cooperation) => (
            <li key={`cooperation-list-${cooperation.name}`}>
              <Link to={linkHandler.get('healthInsuranceCooperation', { cooperation: cooperation.slug })}>{cooperation.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    </Style>
  );
};
